const config = {
    'test': '',
    'AGENT_FLOW_API_MAPPING': {
        'fkdemo:RIDERVERIFICATION_SELFIE_INITIATE': 'https://agentflow.shipsy.io/api/webhooks/trigger/f04d5c87-0d88-4daa-bbfb-1842962cab5d',
        'fkdemo:RIDERVERIFICATION_AADHAAR_VERIFY': 'https://agentflow.shipsy.io/api/webhooks/trigger/e358334f-796f-4215-8b20-0e457ee5562e',
        'fk:RIDERVERIFICATION_SELFIE_INITIATE': 'https://agentflow.shipsy.io/api/webhooks/trigger/5ec3a2ad-11c5-4d60-bb73-04851a3c07af',
        'fk:RIDERVERIFICATION_AADHAAR_VERIFY': 'https://agentflow.shipsy.io/api/webhooks/trigger/32e1aa35-e9c8-4cc1-bfdf-8c71cd51a42e',
'fkfood:RIDERVERIFICATION_SELFIE_INITIATE':
    'https://workflowpieces-gam-fk.shipsy.io/api/webhook/rider-verification-selfie-initiate/fkfood',
    },
    'RIDER_SUPPORT_WORKFLOW_URL_MAPPING': {
        'fkfood:RIDER_SUPPORT_WORKFLOW': 'https://workflowpieces-gam-fk.shipsy.io/api/webhook/rider-support/fkfood',
        'fkfooddemo:RIDER_SUPPORT_WORKFLOW': 'https://workflowpieces-gam-fk.shipsy.io/api/webhook/rider-support/fkfooddemo',
    },
};
module.exports = config;
